import React from 'react';
import { Head } from '@inertiajs/react';
import CategoryForm from '@/components/admin/blog/CategoryForm';

interface Props {
  category?: any;
}

const New: React.FC<Props> = () => {
  return (
    <>
      <Head title="New Category" />
      <CategoryForm isEditing={false} />
    </>
  );
};

export default New;
